import { render } from "./FragenblockModal.vue?vue&type=template&id=b19a40c0&ts=true"
import script from "./FragenblockModal.vue?vue&type=script&lang=ts"
export * from "./FragenblockModal.vue?vue&type=script&lang=ts"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__